import React, { useContext } from "react";
import { PaletteContext } from "./palette_context";
import { KIND_KEY, SHOW_KEY, KINDS } from "@/lib/printess/constants";
import { isProductPlaceholder } from "@/lib/printess/palette/palette_helpers";

const ShowButton = ({ item }) => {
  const { items, setItems } = useContext(PaletteContext);
  const isPlaceholder = isProductPlaceholder(item);

  if (isPlaceholder) return;

  const handleOnClick = () => {
    // Don't do anything if the item is a placeholder (unsaved)
    if (isPlaceholder) return;

    const updates = [];
    const toggledShow = !item[SHOW_KEY];
    updates.push({ ...item, [SHOW_KEY]: toggledShow });

    if (item[KIND_KEY] === KINDS.CATEGORY) {
      const index = items.findIndex((i) => i.key === item.key);
      for (let i = index + 1; i < items.length; i++) {
        const currentItem = items[i];
        const kind = currentItem[KIND_KEY];

        if (kind === KINDS.CATEGORY) {
          // we have reached the next category, which we don't want to handle here.
          break;
        }

        if (kind === KINDS.PRODUCT && !isProductPlaceholder(currentItem)) {
          updates.push({ ...currentItem, [SHOW_KEY]: toggledShow });
        } else {
          updates.push({ ...currentItem });
        }
      }
    }

    setItems((prev) =>
      prev.map((it) => {
        const found = updates.find((u) => u.key === it.key);
        return found ? found : it;
      }),
    );
  };

  return (
    <a
      className={`btn btn-secondary btn-sm ${item[SHOW_KEY] ? "btn-info" : "btn-secondary"}`}
      onClick={handleOnClick}
      title={item[SHOW_KEY] ? `${window.i18n.t("source_menu.icon_popovers.hide")}` : `${window.i18n.t("source_menu.icon_popovers.show")}`}
    >
      <i className="bi bi-eye-fill" />
    </a>
  );
};

export default ShowButton;
